export default ({ request }) => ({
  shipmentFreightDeductionListApi(data = {}) {
    return request({
      url: '/factory/shipment/freight/deduction/list',
      method: 'post',
      data,
    })
  },
  shipmentFreightDeductionDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/freight/deduction/detail',
      method: 'post',
      data,
    })
  },
  shipmentFreightDeductionSaveApi(data = {}) {
    return request({
      url: '/factory/shipment/freight/deduction/save',
      method: 'post',
      data,
    })
  },
  shipmentFreightDeductionDelApi(data = {}) {
    return request({
      url: '/factory/shipment/freight/deduction/del',
      method: 'post',
      data,
    })
  },
  shipmentFreightDeductionSubmitReviewApi(data = {}) {
    return request({
      url: '/factory/shipment/freight/deduction/review',
      method: 'post',
      data,
    })
  },
  shipmentFreightDeductionBookingOptionalApi(data = {}) {
    return request({
      url: '/factory/shipment/freight/deduction/bookingOptional',
      method: 'post',
      data,
    })
  },
})
